import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { checkOcrStatusTimeoutIdSelector, ocrIsLoadingState } from 'shared/states';

export const useStopCheckOcrStatus = () => {
    const setCheckOcrStatusTimeoutId = useSetAtom(checkOcrStatusTimeoutIdSelector);
    const setOcrIsLoading = useSetAtom(ocrIsLoadingState);

    return useCallback(() => {
        setOcrIsLoading(false);
        setCheckOcrStatusTimeoutId(null);
    }, [setCheckOcrStatusTimeoutId, setOcrIsLoading]);
};
